import { GH_TOUR_GATE } from '../../../constants/gates';
import { useAppSelector } from '../../../hooks';
import { useIsUngated } from '../../../hooks/useIsUngated';
import { selectHasGlobalHomeAccess } from '../../../selectors/nav-items.selectors';
import { useDefaultHome } from '../hooks/useDefaultHome';
import { getPortalUserAttributesState } from '../../../reducers/portalUserAttributes';
import { useStartOnboardingTour } from 'nav-onboarding-tours';
import useNavItems from '../../../hooks/useNavItems';
import { GH_BOOKMARKS_Q2_2025_TOUR_ID } from 'nav-onboarding-tours/tours';
import { getPrimaryNavItemForKey } from '../utils/getPrimaryNavItemForKey';
import { jsx as _jsx } from "react/jsx-runtime";
const OnboardingTour = ({
  primaryNavItemId
}) => {
  useStartOnboardingTour({
    type: 'centralizedTourWithOverrides',
    tourId: GH_BOOKMARKS_Q2_2025_TOUR_ID,
    overrides: {
      targetElementSelectorOverrides: {
        'primary-menu-item': `[data-menu-item-group="${primaryNavItemId}"]`
      }
    }
  });
  return null;
};
const MaybeTourIfDefaultHomeExists = () => {
  const {
    homeKey
  } = useDefaultHome();
  const navItems = useNavItems();
  if (!homeKey || homeKey === 'global-home') {
    return null;
  }
  const primaryNavItem = getPrimaryNavItemForKey(homeKey, navItems);
  if (!primaryNavItem) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "global-home-onboarding-tour",
    children: /*#__PURE__*/_jsx(OnboardingTour, {
      primaryNavItemId: primaryNavItem.id
    })
  });
};
export const MaybeGlobalHomeOnboardingTour = () => {
  const hasGlobalHomeAccess = useAppSelector(selectHasGlobalHomeAccess);
  const portalUserAttributes = useAppSelector(getPortalUserAttributesState);
  const isUngated = useIsUngated(GH_TOUR_GATE);
  const hasSeenTour = portalUserAttributes[GH_BOOKMARKS_Q2_2025_TOUR_ID] === 'true';
  if (!hasGlobalHomeAccess || !isUngated || hasSeenTour) {
    return null;
  }
  return /*#__PURE__*/_jsx(MaybeTourIfDefaultHomeExists, {});
};